import { DefaultCSPConfig } from './default';
import { CBACSPConfig } from './cba/cba';
import { MedibankCSPConfig } from './medibank/medibank';
import { BupaCSPConfig } from './bupa/bupa';
import { PIACSPConfig } from './pia/pia';
import { EDICSPConfig } from './edi/edi';
import { BuddyCSPConfig } from './buddy/buddy';
import { TrupanionCSPConfig } from './trupanion/trupanion';
import { HCFCSPConfig } from './hcf/hcf';
import { BWMCSPConfig } from './bwm/bwm';
import { PINSCOMCSPConfig } from './pinscom/pinscom';
import { REALCSPConfig } from './real/real';

export const CSPBrandConfigs = {
  default: DefaultCSPConfig,
  cba: CBACSPConfig,
  medibank: MedibankCSPConfig,
  bupa: BupaCSPConfig,
  pia: PIACSPConfig,
  edi: EDICSPConfig,
  buddy: BuddyCSPConfig,
  trupanion: TrupanionCSPConfig,
  hcf: HCFCSPConfig,
  bwm: BWMCSPConfig,
  pinscom: PINSCOMCSPConfig,
  real: REALCSPConfig
};
